import ResourceUser from '../users/ResourceUser.js';
import ResourceUsers from '../users/ResourceUsers.js';
import ResourceEnums from '../enums/ResourceEnums.js';
import ResourceEnum from '../enums/ResourceEnum.js';
import Rule from '../rule/Rule.js';
import Rules from '../rule/Rules.js';
import Rsrc from '../rsrc/Rsrc.js';
import Device from '../device/Device.js';
import ApiAccessKey from '../apiAccessKey/ApiAccessKey.js';
import ApiAccessKeys from '../apiAccessKey/ApiAccessKeys.js';
class System {
  constructor(id) {
    this.id = id;
  }
  device(id) {
    return Device(id, this.id);
  }
  apiAccessKey(apiAccessKeyId) {
    return new ApiAccessKey({
      apiAccessKeyId,
      resourceId: this.id,
      resourceApi: getSystemApi
    });
  }
  apiAccessKeys() {
    return new ApiAccessKeys({
      resourceId: this.id,
      resourceApi: getSystemApi
    });
  }
  users() {
    return new ResourceUsers({
      resourceId: this.id,
      resourceApi: getSystemApi
    });
  }
  user(userId) {
    return new ResourceUser({
      userId,
      resourceId: this.id,
      resourceApi: getSystemApi
    });
  }
  resourceEnums() {
    return new ResourceEnums({
      resourceId: this.id,
      resourceApi: getSystemApi,
      isResourceLevel: true
    });
  }
  resourceEnum(type) {
    return new ResourceEnum({
      resourceId: this.id,
      type,
      resourceApi: getSystemApi,
      isResourceLevel: true
    });
  }

  // dispatch, getState, opts, ownerId, coownerId, path
  getRsrcApi = (dispatch, getState, opts) => {
    const {
      api
    } = opts;
    return api.system(this.id);
  };
  resource(path) {
    return new Rsrc({
      ownerId: this.id,
      coownerId: null,
      path,
      resourceApi: this.getRsrcApi
    });
  }
  rules() {
    return new Rules({
      resourceId: this.id,
      resourceType: 'system',
      resourceApi: getSystemApi
    });
  }
  rule(ruleId) {
    return new Rule({
      ruleId,
      resourceId: this.id,
      resourceType: 'system',
      resourceApi: getSystemApi
    });
  }
}
function system(id) {
  return new System(id);
}
function getSystemApi(dispatch, getState, opts, resourceId) {
  const {
    api
  } = opts;
  const r = api.system(resourceId);
  return r;
}
export default system;